<template>
  <div class="mb-3">
    <AppSelectCheckboxes
      v-model="selectedDate"
      :items="checkboxDateSelections"
      :label="label"
      item-text="text"
      item-value="value"
      no-margin-bottom
      box-outlined
      value-required
    />
    <div class="text-left primary--text px-2 mt-2 date-text">
      {{ showDate() }}
    </div>
  </div>
</template>
<script>
import AppSelectCheckboxes from "./AppSelectCheckboxes.vue";

export default {
  name: "AppSelectMultipleDatesCheckbox",
  components: { AppSelectCheckboxes },
  props: {
    dateSelections: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    showDate: {
      type: Function,
      required: true
    },
    isCustom: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selectedDate: "custom"
    };
  },
  computed: {
    checkboxDateSelections() {
      const dates = [
        {
          text: this.$t("common:DatePicker.CustomTime.label"),
          value: "custom",
          emit: () => this.$emit("advancedState")
        }
      ];

      return dates.concat(
        this.dateSelections.map(x => {
          x.value = String(x.text);
          x.emit = () =>
            this.$emit("setTime", {
              dateFrom: x.dateFrom,
              dateUntil: x.dateUntil
            });
          return x;
        })
      );
    }
  },
  watch: {
    isCustom(v) {
      if (v == true) this.selectedDate = "custom";
    }
  }
};
</script>
<style scoped>
.date-text {
  font-size: 14px;
  opacity: 0.6;
}
</style>
